import * as yup from 'yup';
yup.setLocale({
        number:{
                min:  'Deber ser mayor que ${min}'
        }
})
export const SimuladorSchema =  yup.object().shape({
        "v_vehiculo" : yup.number().min(1000000),
        "v_inicial" :  yup.number().min(1),
        "plazo" : yup.number().required('es requerido'),
})